export function scaleVideoToCanvasCenterAndKeepRatio({
    videoWidth,
    videoHeight,
    canvasWidth,
    canvasHeight,
}) {
    let scaledWidth = canvasWidth
    let scaledHeight = canvasHeight
    let videoPosY = 0
    let videoPosX = 0

    const videoRatio = videoWidth / videoHeight
    const canvasRatio = canvasWidth / canvasHeight

    if (videoRatio > canvasRatio) {
        scaledWidth = canvasWidth
        scaledHeight = videoHeight * (canvasWidth / videoWidth)
        videoPosY = (canvasHeight - scaledHeight) / 2
    } else {
        scaledHeight = canvasHeight
        scaledWidth = (videoWidth * canvasHeight) / videoHeight
        videoPosX = (canvasWidth - scaledWidth) / 2
    }

    return {
        scaledWidth,
        scaledHeight,
        videoPosY,
        videoPosX,
    }
}
